import i18n from '../../i18n'
import {setTokenValidated} from '../../slices/info/reducer'
import {getInfo, getProfile} from '../../slices/thunks'
import {alertService} from './alerts'
import {validateToken} from './validateToken'

export const setupAuthenticatedSession = async (authToken, dispatch) => {
  if (authToken) {
    const isTokenValid = await validateToken()

    if (isTokenValid) {
      dispatch(setTokenValidated())
      dispatch(getProfile())
      dispatch(getInfo())
    } else {
      localStorage.clear()

      if (window.navigate) {
        window.navigate('/login')
        alertService.error({
          heading: i18n.t('SESSION_EXPIRED'),
          message: i18n.t('SESSION_EXPIRED_MESSAGE')
        })
      } else {
        // eslint-disable-next-line no-restricted-globals
        location.replace('/login')
      }
    }
  }
}
